import React from "react";
import useFetchData from "./FetchData";
import { useNavigate } from "react-router-dom";
//شمسی
import moment from "moment-jalaali";
import { DELETE_PROJECT_TEAMHEAD , GET_APPROVEPROJECT_TEAMHEAD} from "helpers/url_helper";
import { ToastContainer, toast } from "react-toastify";
import { APIClient } from "helpers/api_helper";

const api = new APIClient();
const TableProjects = () => {
  let x = 1;
  let { data, loading } = useFetchData();
console.log(data)
  const history = useNavigate();

  const handleNavigationReqWork = (id: any) => {
    history(`/TeamHead/ReqWork/Requestlist?projectId=${id}`);
  };
  const handleNavigationProduct = (id: any) => {
    history(`/TeamHead/Product/Productlist?projectId=${id}`);
  };
  const handleNavigationEstimateOfProject = (id: any) => {
    history(`/TeamHead/Estimate/estimateWorkOfProject?projectId=${id}`);
  };

  const handleNavigationDesignContract = (id: any) => {
    history(`/TeamHead/designContract/create?projectId=${id}`);
  };
  const handleProjectDetail = (id: any) => {
    history(`/TeamHead/Project/detail?projectId=${id}`);
  };


  const handleNavigationApproveProject = (id: any) => {
    const fetchData = async () => {
      try {
        await api
          .get(GET_APPROVEPROJECT_TEAMHEAD, { projectId: id })
          .then(() => {
            window.location.reload();
          });
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  };
  const handleNavigationImplementContract = (id: any) => {
    history(`/TeamHead/exeContract/create?projectId=${id}`);
  };
  const handleDeleteProject = async (projectId: any) => {
    try {
       // نمایش پیام تأیید به کاربر
    const userConfirmed = window.confirm("آیا مطمئن هستید که می‌خواهید این پروژه را حذف کنید؟");

    // اگر کاربر تأیید نکرد، عملیات حذف لغو شود
    if (!userConfirmed) {
      return;}
      const postDate = {
        projectId: projectId,
      };
      console.log(postDate);
      
      await api.get(DELETE_PROJECT_TEAMHEAD, postDate);
      toast.info("پروژه با موفقیت حذف شد");
      // Reload the page to reflect changes
      window.location.reload();
    } catch (error) {
      toast.error("Error");
    }
  };

  if (loading) return <p>loading ...</p>;
  return (
    <React.Fragment>
      <div className="card">
        <div className="card-body">
          <h6 className="mb-12 text-15">لیست پروژه ها</h6>

          <div className="overflow-x-auto">
            <table className="w-full bg-custom-50 dark:bg-custom-500/10">
              <thead className="ltr:text-left rtl:text-right bg-custom-100 dark:bg-custom-500/10">
                <tr>
                  <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900">
                    ردیف
                  </th>
                  <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900">
                    تاریخ
                  </th>
                  {/* <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900">
                    تیم
                  </th> */}
                  <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900">
                    شهر
                  </th>
                  
                  <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900">
                    نام کارفرما
                  </th>
                  <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900">
                    تایید معاون فنی 
                  </th>
                  <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900">
                    کد پروژه
                  </th>
                  <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900">
                    عملیات
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* <tr> */}
                {!loading &&
                  data.projects.map((project) => (
                    <tr key={project.id}>
                      <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">
                        <a
                          href="#!" // Use downloadLink if available, otherwise fallback to "#"
                          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
                        >
                          {x++}
                        </a>
                      </td>
                      <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">
                        {/* {project.createdDate || "-"}{" "} */}
                        {project && project.createdDate
                          ? moment(project.createdDate, "YYYY-MM-DD").format(
                              "jYYYY/jMM/jDD"
                            )
                          : "-"}
                      </td>
                      {/* <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">
                        {project.teamName || "-"}{" "}
                      </td> */}
                      <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">
                        {project.city || "-"}{" "}
                      </td>
                    
                      <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">
                        {project.employeName || "-"}{" "}
                      </td>
                      <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">
                        {project.approvedByTechnicalDeputy ? (
                          <span className="px-2.5 py-0.5 text-xs font-medium inline-block rounded border bg-custom-500 border-custom-500 text-custom-50">
                            تایید شده
                          </span>
                        ) : (
                          <span className="px-2.5 py-0.5 text-xs font-medium inline-block rounded border bg-red-500 border-red-500 text-red-50">
                            تایید نشده 
                          </span>
                        )}
                        </td>
                      <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">
                        {project.projectCode || "-"}{" "}
                      </td>
                      <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">
                        <button
                          style={{
                            display: "inline-block",
                            backgroundColor: "blue",
                            color: "white",
                            padding: "10px 20px 10px",
                            border: "none",
                            marginRight: "3px",
                            marginTop: "3px",
                          }}
                          onClick={() => handleNavigationReqWork(project.id)}
                          className="btn btn-primary"
                        >
                          جبهه های کاری
                        </button>
                        <button
                          style={{
                            display: "inline-block",
                            backgroundColor: "blue",
                            color: "white",
                            padding: "10px 20px 10px",
                            border: "none",
                            marginRight: "3px",
                            marginTop: "3px",
                          }}
                          onClick={() => handleNavigationProduct(project.id)}
                          className="btn btn-primary"
                        >
                          محصولات
                        </button>
                        <button
                          style={{
                            display: "inline-block",
                            backgroundColor: "green",
                            color: "white",
                            padding: "10px 20px 10px",
                            border: "none",
                            marginRight: "3px",
                            marginTop: "3px",
                          }}
                          onClick={() =>
                            handleNavigationEstimateOfProject(project.id)
                          }
                          className="btn btn-primary"
                        >
                          برآورد کارهای پروژه
                        </button>
                        <button
                          style={{
                            display: "inline-block",
                            backgroundColor: "#6c757d",
                            color: "white",
                            padding: "10px 20px 10px",
                            border: "none",
                            marginRight: "3px",
                            marginTop: "3px",
                          }}
                          onClick={() =>
                            handleNavigationImplementContract(project.id)
                          }
                          className="btn btn-primary"
                        >
                            قرارداد اجرا
                        </button>
                        <button
                          style={{
                            display: "inline-block",
                            backgroundColor: "#6c757d",
                            color: "white",
                            padding: "10px 20px 10px",
                            border: "none",
                            marginRight: "3px",
                            marginTop: "3px",
                          }}
                          onClick={() =>
                            handleNavigationDesignContract(project.id)
                          }
                          className="btn btn-primary"
                        >
                            قرارداد طراحی
                        </button>
                        <button
                          style={{
                            display: "inline-block",
                            backgroundColor: "#1b143e",
                            color: "white",
                            padding: "10px 20px 10px",
                            border: "none",
                            marginRight: "3px",
                            marginTop: "3px",
                          }}
                          onClick={() => handleProjectDetail(project.id)}
                          className="btn btn-primary"
                        >
                          ویرایش پروژه
                        </button>
                        {  ( project.isApprovedByTeamHead === false )  &&
                        <button
                            style={{
                              display: "inline-block",
                              backgroundColor: "green",
                              color: "white",
                              padding: "10px 20px 10px",
                              border: "none",
                              marginRight: "3px",
                              marginTop: "3px",
                            }}
                            onClick={() =>
                              handleNavigationApproveProject(project.id)
                            }
                            className="btn btn-primary"
                          >
                            تایید پروژه
                          </button>}
                        <button
                          style={{
                            display: "inline-block",
                            backgroundColor: "red",
                            color: "white",
                            padding: "10px 20px 10px",
                            border: "none",
                            marginRight: "3px",
                            marginTop: "3px",
                          }}
                          onClick={() => handleDeleteProject(project.id)}
                          className="btn btn-primary"
                        >
                          حذف پروژه
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TableProjects;
